/**
 * @generated SignedSource<<a5c8d971b1a238588e07fbc52cd630d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ParseProductPromptInput = {
  prompt: string;
};
export type printAreasParseProductPromptMutation$variables = {
  input: ParseProductPromptInput;
};
export type printAreasParseProductPromptMutation$data = {
  readonly parseProductPrompt: {
    readonly error: string | null;
    readonly handoffPrompt: string | null;
    readonly outOfScope: boolean;
    readonly productName: string;
    readonly sides: ReadonlyArray<{
      readonly imagePrompt: string;
      readonly name: string;
    }>;
    readonly success: boolean;
    readonly supportRequest: {
      readonly description: string;
      readonly subject: string;
    } | null;
  };
};
export type printAreasParseProductPromptMutation = {
  response: printAreasParseProductPromptMutation$data;
  variables: printAreasParseProductPromptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ParseProductPromptOutput",
    "kind": "LinkedField",
    "name": "parseProductPrompt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailSupportRequest",
        "kind": "LinkedField",
        "name": "supportRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outOfScope",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "handoffPrompt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ParsedProductSide",
        "kind": "LinkedField",
        "name": "sides",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imagePrompt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printAreasParseProductPromptMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "printAreasParseProductPromptMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "63c75b0b4b7d54e6a4730b2350e00bc9",
    "id": null,
    "metadata": {},
    "name": "printAreasParseProductPromptMutation",
    "operationKind": "mutation",
    "text": "mutation printAreasParseProductPromptMutation(\n  $input: ParseProductPromptInput!\n) {\n  parseProductPrompt(input: $input) {\n    success\n    error\n    supportRequest {\n      subject\n      description\n    }\n    outOfScope\n    handoffPrompt\n    productName\n    sides {\n      name\n      imagePrompt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "34ac240b505be859ab64417c0a7c614c";

export default node;
